<template>
  <section
    id="cases"
    ref="casesRef"
    class="cases transition-all duration-1000 ease-out landing-container pt-120px pb-46px lt-sm:pt-120px lt-sm:pb-60px lt-sm:px-32px"
    :class="[isCasesVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-50px']"
  >
    <div class="cases-header text-center mb-60px lt-sm:mb-60px lt-sm:px-32px">
      <h2
        class="cases-title pf-sc-semibold font-s-36px font-semibold text-#000000 mb-4px lh-60px lt-sm:font-s-48px lt-sm:mb-16px"
      >
        知识产权和案例
      </h2>
      <p
        class="cases-desc pf-sc-regular font-s-16px text-main/70 lh-30px lt-sm:font-s-24px lt-sm:lh-40px lt-sm:px-70px"
      >
        绘家科技凭借强大的技术实力和丰富的实践经验，为客户提供卓越的智慧社区解决方案
      </p>
    </div>

    <div
      ref="casesListRef"
      class="cases-list flex gap-24px lt-sm:gap-42px lt-sm:overflow-x-auto lt-sm:overflow-y-hidden lt-sm:px-0 lt-sm:pb-10px lt-sm:[scroll-snap-type:x_mandatory] lt-sm:[scrollbar-width:none] lt-sm:mx-[-32px]"
      @scroll="handleCaseScroll"
    >
      <section-cases-card
        v-for="(caseItem, index) in cases"
        :key="caseItem.title"
        :case-item="caseItem"
        :is-active="index === activeCaseIndex"
      />
    </div>

    <div
      class="cases-dots lt-sm:flex hidden lt-sm:mt-40px lt-sm:flex-center lt-sm:gap-16px"
      role="tablist"
      aria-label="案例切换"
    >
      <div
        v-for="(_, index) in cases"
        :key="index"
        class="dot lt-sm:w-60px lt-sm:h-10px bg-#E5E9F5 rounded-full transition-all cursor-pointer focus-visible:outline-primary"
        :class="{ active: index === activeCaseIndex }"
        role="tab"
        :aria-selected="index === activeCaseIndex"
        :aria-label="`切换到案例 ${index + 1}`"
        tabindex="0"
        @click="scrollToCase(index)"
        @keydown.enter="scrollToCase(index)"
        @keydown.space.prevent="scrollToCase(index)"
      ></div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { cases } from '@/constants/common'

  const casesRef = ref<HTMLElement | null>(null)
  const { isVisible: isCasesVisible } = useScrollReveal(casesRef)
  const activeCaseIndex = ref(0)
  const casesListRef = ref<HTMLElement | null>(null)

  const handleCaseScroll = (e: Event) => {
    const el = e.target as HTMLElement
    const scrollLeft = el.scrollLeft
    const width = el.offsetWidth
    const cardWidth = width * 0.9
    const gap = 16
    const newIndex = Math.round(scrollLeft / (cardWidth + gap))
    if (newIndex !== activeCaseIndex.value) {
      activeCaseIndex.value = newIndex
    }
  }

  const scrollToCase = (index: number) => {
    if (!casesListRef.value) return
    const width = casesListRef.value.offsetWidth
    const cardWidth = width * 0.9
    const gap = 16
    casesListRef.value.scrollTo({
      left: index * (cardWidth + gap),
      behavior: 'smooth',
    })
  }
</script>

<style scoped>
  .cases-list::-webkit-scrollbar {
    display: none;
  }

  .cases-card:first-child {
    @apply lt-sm:ml-42px;
  }

  .cases-card:last-child {
    @apply lt-sm:mr-42px;
  }

  @screen lt-sm {
    .cases-list::-webkit-scrollbar {
      display: none;
    }
  }

  .dot.active {
    background-color: #0f67f8 !important;
  }
</style>
